import { render, staticRenderFns } from "./CustomerGeneralNoteForm.vue?vue&type=template&id=1f1b9811&"
import script from "./CustomerGeneralNoteForm.vue?vue&type=script&lang=js&"
export * from "./CustomerGeneralNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports